import { lazy } from "react";

// Módulo OCULTO temporalmente: el sistema de call assignments se va a
// rediseñar por completo. Siguiendo la convención (el módulo resuelve su
// propio flag), con el flag en false se exporta [] y la ruta no se monta;
// el código queda intacto para la próxima iteración.
const CALL_ASSIGNMENTS_ENABLED = false;

const CallAssignmentsPage = lazy(() => import("./pages/CallAssignmentsPage"));

export const callAssignmentsRoutes = CALL_ASSIGNMENTS_ENABLED
  ? [{ path: "/call-assignments", element: <CallAssignmentsPage /> }]
  : [];
